document.addEventListener('DOMContentLoaded', function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const EASING = 'cubic-bezier(0.25, 0.46, 0.45, 0.94)';
  const DURATION = '0.6s';
  const STAGGER = 100;

  function buildObserver(entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('prestige-visible');
        observer.unobserve(entry.target);
      }
    });
  }

  const observer = new IntersectionObserver(buildObserver, {
    threshold: 0.12,
    rootMargin: '0px 0px -40px 0px',
  });

  /* Headings — fade up */
  document.querySelectorAll(
    'h1:not(.visually-hidden), h2:not(.visually-hidden), h3:not(.visually-hidden)'
  ).forEach(function (el) {
    if (!el.closest('.hero') && !el.closest('header-component')) {
      el.classList.add('prestige-fade-up');
      observer.observe(el);
    }
  });

  /* Product cards — staggered fade up */
  document.querySelectorAll('.product-card').forEach(function (card, i) {
    card.classList.add('prestige-fade-up');
    card.style.transitionDelay = (i % 4) * STAGGER + 'ms';
    observer.observe(card);
  });

  /* Section images — fade in */
  document.querySelectorAll('.section img:not(.product-card img)').forEach(function (img) {
    if (!img.closest('header-component') && !img.closest('footer')) {
      img.classList.add('prestige-fade-in');
      observer.observe(img);
    }
  });
});
